import React from 'react';
import './DecisionTag.css';

// A decision's status as a small pill — same colours everywhere it shows
// (Beslutninger & risici, Noter). `badge` is what getStatusBadge / the page's
// displayStatus return: { label, tone }.
export default function DecisionTag({ badge, children }) {
  if (!badge && !children) return null;
  return <span className={`dt-tag dt-tag--${badge?.tone || 'neutral'}`}>{children || badge.label}</span>;
}
